import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'simultaneousInterpretation',
    component: () => import('@/views/simultaneousInterpretation.vue'),
    meta: {
      title: '首页',
    }
  },
  {
    path: '/simultaneousInterpretation',
    name: 'simultaneousInterpretation',
    component: () => import('@/views/simultaneousInterpretation.vue'),
    meta: {
      title: '同声传译',
    }
  },
  
  {
    path: '*',
    redirect: '/'
  }
]

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})